import { useQuery, UseQueryResult } from 'react-query';
import { Snippet, SnippetType } from '../../models';
import { fetchSnippet } from '../../services/snippets/snippets.service';
import { queryKeys } from '../queryKeyFactory';

export default (type: SnippetType, id: string): UseQueryResult<Snippet, Error> => {
  return useQuery<Snippet, Error>(queryKeys.fetchSnippets.single(type, id), async () => fetchSnippet(type, id));
};
